import store from '@/store/index.js'
export function success(that, message, dangerouslyUseHTMLString = false) {
	that.$message({
    dangerouslyUseHTMLString: dangerouslyUseHTMLString,
		message,
		type: 'success',
   
	});
};

export function warning(that, message, dangerouslyUseHTMLString = false) {
	// duration=duration||1000;
	that.$message({
    dangerouslyUseHTMLString: dangerouslyUseHTMLString,
		message,
		type: 'warning',
	});
};


export function info(that, message, dangerouslyUseHTMLString = false) {
	that.$message({
    dangerouslyUseHTMLString: dangerouslyUseHTMLString,
		message,
		type: 'info',
	});
};

export function error(that, message, dangerouslyUseHTMLString = false) {
	that.$message({
    dangerouslyUseHTMLString: dangerouslyUseHTMLString,
		message,
		type: 'error',
    
    
	});
};
export function alerterror(that, statuscode,duration) {
	duration=duration||1000;
	var lang = store.state.lang;
  var model = store.state.errorInfor;
  model = model.find( param => {return param["Key"] == statuscode;})
  if(model != null){
    if(model["Value"] != null){
      error(that, model.Value);
    }else if (lang == "zh-cn") {
        error(that, model.CnMessage);
      } else if (lang == "en-us") {
        error(that, model.EnMessage);
      }
  }
}
export function alertsuccess(that, statuscode) {
  var lang = store.state.lang;
  var model = store.state.errorInfor;
  // console.log(model)
  model = model.find( param => {return param["Key"] == statuscode;})
  if(model != null){
    if(model["Value"] != null){
      success(that, model.Value);
    }else if (lang == "zh-cn") {
        success(that, model.CnMessage);
      } else if (lang == "en-us") {
        success(that, model.EnMessage);
      }else if(lang == "de"){
        // success(that, model.EnMessage);
      }
  }
  model = null;
}

//根据返回码获得对应返回消息
export const returnmessage=(statuscode)=>{
	var lang = store.state.lang;
	var model = store.state.errorInfor;
  model = model.find( param => {return param["Key"] == statuscode;})
  if(model != null){
    if(model["Value"] != null){
      return model["Value"];
    }else if (lang == "zh-cn") {
        return model.CnMessage;
      } else if (lang == "en-us") {
        return model.EnMessage;
      }
  }else{
    return '';
  }
}

export const isNullString=(str)=>{
	if(str!=""&&str!=null){
		return true;
	}else{
		return false;
	}
}